/**
 * 文件作用：适配器统一注册入口（从集中配置读取模型信息）
 * - 遍历 models.config.ts 中的 ModelConfigEntry，按 modelKey + taskType 注册适配器
 * - 新增模型时，只需在 models.config.ts 中添加条目并提供适配器实现，即可自动完成注册
 */
import { registerAdapter } from './registry';
import { listModelConfigs } from '../config/models.config';

// 注册所有适配器（基于集中式配置，避免 modelKey/taskType 重复维护）
export const registerAllAdapters = () => {
  listModelConfigs().forEach((config) => {
    try {
      // 仅使用 modelKey 作为注册标识符，其他别名在 lookup 层处理
      if (config.modelKey) {
        registerAdapter(config.modelKey, config.defaultTaskType, config.adapter);
      }
    } catch (error) {
      console.warn(`register adapter failed: ${config.modelKey}`, error);
    }
  });
};

// 立即注册，确保 import 本模块即可完成初始化
registerAllAdapters();

export default registerAllAdapters;
